import * as React from "react"
import { Calendar, ExternalLink, ImageIcon } from "lucide-react"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "./dialog"
import { ButtonWidget } from "./button-widget"
import { cn } from "../../lib/utils"

export interface ContentEntry {
  title: string
  description: string
  date: string
  link: string
  linkText?: string
  image?: string
}

interface ModalViewProps {
  entry: ContentEntry
  trigger: React.ReactNode
  className?: string
  showImage?: boolean
}

const ModalView: React.FC<ModalViewProps> = ({ entry, trigger, className, showImage = true, ...props }) => {
  return (
    <Dialog {...props}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className={cn("dsw-max-w-2xl", className)}>
        <DialogHeader>
          <DialogTitle className="dsw-flex dsw-items-center dsw-gap-2 dsw-mb-2">
            {entry.title}
            <span className="dsw-flex dsw-items-center dsw-gap-1 dsw-text-xs dsw-text-muted-foreground dsw-font-normal">
              <Calendar className="dsw-h-3 dsw-w-3" />
              {entry.date}
            </span>
          </DialogTitle>
          <DialogDescription>
            {entry.description}
          </DialogDescription>
        </DialogHeader>
        
        {showImage && (
          <div className="dsw-aspect-video dsw-bg-muted dsw-flex dsw-items-center dsw-justify-center dsw-rounded-lg dsw-my-4">
            {entry.image ? (
              <img 
                src={entry.image} 
                alt={entry.title}
                className="dsw-w-full dsw-h-full dsw-object-cover dsw-rounded-lg"
              />
            ) : (
              <ImageIcon className="dsw-h-16 dsw-w-16 dsw-text-muted-foreground" />
            )}
          </div>
        )}

        <DialogFooter>
          <ButtonWidget asChild>
            <a href={entry.link} target="_blank" rel="noopener noreferrer" className="dsw-flex dsw-items-center">
              <ExternalLink className="dsw-h-4 dsw-w-4 dsw-mr-2" />
              {entry.linkText || "Open Link"}
            </a>
          </ButtonWidget>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { ModalView } 